import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";

// Only English is enabled for now. Other locales exist structurally but are
// untested, so detection is constrained to the supported set to prevent a
// previously-saved or browser-detected locale from stranding a user on an
// untested language. Expand this list to re-enable additional languages.
const supportedLanguages = ["en"];

// Language detection helper
const getInitialLanguage = (): string => {
  // Check localStorage first (only honour it if still supported)
  const savedLanguage = localStorage.getItem("i18nextLng");
  if (savedLanguage && supportedLanguages.includes(savedLanguage)) {
    return savedLanguage;
  }

  // Check browser language
  const browserLanguage = navigator.language.split("-")[0];

  return supportedLanguages.includes(browserLanguage) ? browserLanguage : "en";
};

i18n
  .use(HttpBackend) // Load translations from files
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    lng: getInitialLanguage(),
    fallbackLng: "en",
    debug: import.meta.env.DEV, // Enable debug in development

    // Backend configuration for loading translation files
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
      // Add cache busting in development
      queryStringParams: import.meta.env.DEV
        ? { v: Date.now().toString() }
        : {},
    },

    // Namespace configuration
    ns: ["common"],
    defaultNS: "common",

    // Interpolation configuration
    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // React-specific options
    react: {
      useSuspense: false, // Disable suspense for better error handling
    },

    // Save language preference to localStorage
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
